const spacesAtEndRegExp = /\s+$/;
export const hasSpacesAtEnd = str => spacesAtEndRegExp.test(str);
const spacesAtBeginningRegExp = /^\s+/;
export const hasSpacesAtBeginning = str => spacesAtBeginningRegExp.test(str);